module.exports = __webpack_public_path__ + "assets/img/Cutting-Edge-Coaching.b7b63d68.png";